import React from "react";
// import Prettyfier from 'components/UI/Prettyfier';
import Paragrapher from "components/UI/Paragrapher";
let _LOCALE = null;
import(`../i18n/${process.env.REACT_APP_SITE}_fr.js`).then((module) => {
  _LOCALE = module.default;
});
const get = (string, options) => {
  if(!_LOCALE) return "";
  let r, s;
  r = _LOCALE[string] !== undefined ? _LOCALE[string] : string;
  if(string !== false && ((options !== undefined && options.pretty === true) || options === undefined || options.pretty !== false)) s = (<Paragrapher
        prettyfy={true}
        substitute={options !== undefined && options.substitute ? options.substitute : undefined}
        text={r}
        element={options !== undefined && options.element ? options.element : "span"}
        elementStyle={{
          // display: "inline-block",
          // verticalAlign: "middle",
          // minHeight: "16px",
          // marginBottom: 10,
          display: "block",
          // verticalAlign: "middle",
          minHeight: "16px",
          // marginBottom: 10,
        }}
      />);
  else s = r;
  return s;
};
const has = (string) => {
  if(!_LOCALE) return "";
  return _LOCALE[string] !== undefined && _LOCALE[string] !== false;
};
export default {
  get,
  has,
};



// WEBPACK FOOTER //
// ./src/helpers/i18n.js